import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { usePaginatedQuery, ErrorHandler, captureException } from '@playbookux/playbook-web-core';
import PropTypes from 'prop-types';

import UsageTable from './custom-table';
import {
  exportUsage,
  downloadExportProject,
} from '../../../../core/services/export';
import ExportDialog from '../../../../core/components/export-project-dialog';

import {
  Loader,
  Title,
  Text,
  Button,
  UsageHeader,
} from './styles';

import {
  GET_USAGE_LOGS_BY_COMPANY,
} from '../graphql';

const Usage = (props) => {
  const { companyId } = props;

  const attributes = {
    variables: {
      limit: 100,
      offset: 0,
      order: 'created_at DESC',
      companyId,
    },
    fetchPolicy: 'network-only',
  };

  const {
    error,
    loading,
    data = {},
    fetchMore,
    hasMore,
  } = usePaginatedQuery(GET_USAGE_LOGS_BY_COMPANY, attributes, { dataField: 'usageLogsByCompany' });

  const { usageLogsByCompany = [] } = data;
  const [showExport, setShowExport] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [errorExport, setErrorExport] = useState(false);
  const [exportBlob, setExportBlob] = useState({});

  const handleExport = async () => {
    try {
      let blobInfo = {};
      setShowExport(true);
      setLoadingExport(true);
      blobInfo = await exportUsage(companyId, false);

      setExportBlob(blobInfo);
      setLoadingExport(false);
    } catch (err) {
      setLoadingExport(false);
      setErrorExport(true);
      captureException('HANDLE_EXPORT_FAILED', err);
    }
  };

  const handleDownloadExport = async () => {
    try {
      await downloadExportProject(exportBlob);
      setShowExport(false);
    } catch (err) {
      captureException('HANDLE_EXPORT_FAILED', err);
    }
  };

  const handleCloseExport = () => {
    setShowExport(false);
    setErrorExport(false);
  };

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Something went wrong while retrieving data."
      />
    );
  }

  if (loading) {
    return (
      <Loader data-loader="usage-loader" />
    );
  }

  return (
    <>
      <UsageHeader>
        <Title as="h2">Work Log</Title>
        <Button
          onClick={handleExport}
        >
          Export
        </Button>
      </UsageHeader>
      <Text>
        Learn more about this
        {' '}
        <a
          href="http://help.playbookux.com/en/articles/6970610-usage-report"
          target="_blank"
          rel="noopener noreferrer"
        >
          usage report
        </a>
      </Text>
      <UsageTable
        usageLogs={usageLogsByCompany}
        fetchMore={fetchMore}
        hasMore={hasMore}
        admin={false}
      />
      <ExportDialog
        show={showExport}
        loadingExport={loadingExport}
        downloadExport={handleDownloadExport}
        handleClose={handleCloseExport}
        errorExport={errorExport}
      />
    </>

  );
};

const mapStateToProps = ({ authentication }) => ({
  companyId: authentication.company?.id,
});

const enhance = compose(
  connect(mapStateToProps, null),
);

Usage.propTypes = {
  companyId: PropTypes.string.isRequired,
};

export default enhance(Usage);
